import React, { Fragment, useEffect, useState, useRef } from "react";
import cx from "classnames";

import { connect, useSelector, useDispatch } from "react-redux";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import HeaderLogo from "../AppLogo";
import UserBox from "./Components/UserBox";
import { Roles } from "../../utils/Roles";
// import HeaderRightDrawer from "./Components/HeaderRightDrawer";
import { useHistory, useLocation } from "react-router";
import GetStudentService from "../../services/SchoolIT/GetStudentService";

import HeaderDots from "./Components/HeaderDots";
import Switch from "react-switch";
import CustomLoader from "../../components/customLoader/CustomLoader";
import MessageBell from "../../assets/images/bell/MessageBell.png";
import MsgDataService from "../../services/MsgService";
import { messageNotificationAction } from "../../reducers/MessageNotificationReducer";
import { setLanguage } from "../../reducers/LanguageReducer";
import LanguageService from "../../services/LanguageService";
import swal from "sweetalert";
import { stopImpersonation } from "../../reducers/ImpersonationReducer";
import { userInfoAction } from "../../reducers/UserReducer";
import Storage from "../../services/Storage";

const Header = () => {
  let { headerBackgroundColor, enableMobileMenuSmall, enableHeaderShadow, closedSmallerSidebar } = useSelector(state => state.ThemeOptions);
  const [user, setUser] = useState(useSelector(state => state.UserReducer.userObj));
  const reduxUser = useSelector(state => state.UserReducer.userObj);
  let notificationCount = useSelector(state => state.MessageNotificationReducer.messageNotification);
  const impersonation = useSelector(state => state.ImpersonationReducer);
  let dispatch = useDispatch();
  let location = useLocation();
  let history = useHistory();
  const [openSchoolOption, setOpenSchoolOption] = useState(false);
  const [schoolName, setSchoolName] = useState(JSON.parse(localStorage.getItem("user"))?.school_name);
  const [selectedSchool, setSelectedSchool] = useState();
  const [userOnRoute, setUserOnRoute] = useState(location?.pathname.split('/').pop())



  const [modifyData, setModifyData] = useState({});
  const [schoolId, setSchoolId] = useState();
  const [schoolName1, setSchoolName1] = useState(JSON.parse(localStorage.getItem("user"))?.school_name);
  // const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [openUploadSchool, setOpenUploadSchool] = useState(false);
  const [openNewSchool, setOpenNewSchool] = useState(false);
  const [openModifySchool, setOpenModifySchool] = useState(false);
  const [enableState, setEnableState] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  // Language toggle (EN/ES) uses global Redux state
  const currentLang = useSelector((state) => state.LanguageReducer.current) || 'en';
  const [languageEs, setLanguageEs] = useState(currentLang === 'es');
  const handleLanguageToggle = (checked) => {
    const prevLang = (currentLang || 'en').toLowerCase();
    const nextLang = checked ? 'es' : 'en';
    setLanguageEs(checked);
    dispatch(setLanguage(nextLang));
    // Persist and broadcast for any legacy listeners
    try {
      localStorage.setItem('preferred_language', nextLang);
      const evt = new CustomEvent('languageChange', { detail: { lang: nextLang } });
      window.dispatchEvent(evt);
    } catch (e) {}

    // Call backend to persist for Student/Parent roles
    if (user?.role === Roles.STUDENT_NAME || user?.role === Roles.PARENT_NAME) {
      LanguageService.setUserLanguage(nextLang, user?.role)
        .then(() => {
          // no-op on success
        })
        .catch((error) => {
          // Rollback on failure
          dispatch(setLanguage(prevLang));
          setLanguageEs(prevLang === 'es');
          try {
            localStorage.setItem('preferred_language', prevLang);
            const evt = new CustomEvent('languageChange', { detail: { lang: prevLang } });
            window.dispatchEvent(evt);
          } catch (e) {}
          swal("", error?.response?.data?.message || "Failed to update language. Please try again.", "error");
        });
    }
  };

  // Keep localStorage and toggle in sync with Redux language
  useEffect(() => {
    setLanguageEs(currentLang === 'es');
    try {
      localStorage.setItem('preferred_language', currentLang);
    } catch (e) {}
  }, [currentLang]);

  // Optional compatibility: reflect window event into Redux
  useEffect(() => {
    const onLangChange = (e) => {
      const next = (e?.detail?.lang || 'en').toLowerCase();
      if (next !== currentLang) {
        dispatch(setLanguage(next));
      }
    };
    window.addEventListener('languageChange', onLangChange);
    return () => window.removeEventListener('languageChange', onLangChange);
  }, [currentLang, dispatch]);

  const getCounselorNotificationCount = () => {
    MsgDataService.getCounselorNotificationCount()
      .then((res) => {
        if (res?.status === 200) {
          // Show total_notification count for all roles
          const totalCount = res?.data?.total_notification || 0;
          dispatch(messageNotificationAction(totalCount));
        }
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const handleBellClick = () => {
    if (user?.role === Roles.COUNSELOR_NAME) {
      history.push("/counselor/message/student-message");
    } else if (user?.role === Roles.ADMIN_NAME) {
      history.push("/super_admin/message/student-message");
    } else if (user?.role === Roles.RECRUITER_NAME) {
      history.push("/recruiter/students");
    }
  };

  useEffect(() => {
    if (user?.role === Roles.COUNSELOR_NAME || user?.role === Roles.ADMIN_NAME || user?.role === Roles.RECRUITER_NAME) {
      getCounselorNotificationCount();
    }
  }, [user]);

  const openSchoolOptionHandler = () => {
    setOpenSchoolOption(!openSchoolOption);
  };

  const selectSchoolOptionHandler = (value) => {
    console.log(value);
    setSchoolName1(value.name);
    setSelectedSchool(value);
    setOpenSchoolOption(false);
  };


  useEffect(() => {
    // if(user.role === "counsellor")
    if (selectedSchool) {
      console.log("selected School", selectedSchool);
      let obj = {
        ...user,
        school_id: selectedSchool?.id,
        school_name: selectedSchool?.name,
      };
      localStorage.setItem("user", JSON.stringify(obj));
      if (
        user?.role === "counselor" &&
        user?.is_super_counselor === true && userOnRoute !== "all-students"
      ) {
        console.log("1");
        history.push("/super_admin/all-students");
      } else if (
        user?.role === "counselor" &&
        user?.is_super_counselor === false && userOnRoute !== "all-students"
      ) {
        console.log("2");
        history.push("/counselor/all-students");
      } else if (userOnRoute === "all-students" && user?.role === "counselor" && user?.is_super_counselor === true) {
        console.log("3");
        window.location.reload();
      } else if (userOnRoute === "all-students" && user?.role === "counselor" && user?.is_super_counselor === false) {
        console.log("4");
        window.location.reload();
      }
    }
  }, [selectedSchool]);


  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    let obj = {
      q: value
    }
    GetStudentService.getSchoolsList(obj)
      .then((data) => {
        console.log("data from the service", data);
        setSchoolNameList(data?.data?.school);

        setSchoolNameLoading(false);
        setShowSchoolNameContainer(true);
      })
      .catch((error) => {
        console.log("error from the service", error);
        setSchoolNameLoading(false);
      });
  };

  const handleSchoolName = () => {
    const searchTerm = schoolNameRef.current.value.toLowerCase();
    setSchoolName1(searchTerm);

    if (!searchTerm) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      // Filter schools from user.schools_name instead of API call
      const filteredSchools = user?.schools_name?.filter(school =>
        school.name.toLowerCase().includes(searchTerm)
      ) || [];

      setSchoolNameList(filteredSchools);
      setShowSchoolNameContainer(true);
    }
  };

  // useEffect(() => {
  //   if (selectedSchool) {
  //     console.log("selected School", selectedSchool);
  //     let obj = {
  //       ...user,
  //       school_id: selectedSchool?.id,
  //       school_name: selectedSchool?.name,
  //     };
  //     localStorage.setItem("user", JSON.stringify(obj));
  //   window.location.reload();
  // }}, [selectedSchool]);


  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName1(item?.name);
    // setOpenModifySchool(true);
    setEnableState(true);
    setModifyData(item);
    setSchoolId(item?.id);
    // setSchoolName('');
    // else if (selectedSchool && user.role === "school_it"){
    let obj = {
      ...user,
      school_id: item?.id,
      school_name: item?.name,
      district: item?.id,
      district_name: item?.name,
      counselor_id: item?.counselor_id,
    };
    localStorage.setItem("user", JSON.stringify(obj));
    window.location.reload();
  };

  // Keep local user state in sync with Redux (important for impersonation)
  useEffect(() => {
    setUser(reduxUser);
  }, [reduxUser]);

  const handleExitImpersonation = () => {
    // Try to get context from Redux first, then fallback to localStorage
    let originalAdmin = impersonation.originalAdminUser;
    let originalAdminToken = impersonation.originalAdminToken;
    let returnSchoolId = impersonation.returnSchoolId;
    let returnStudentId = impersonation.returnStudentId;
    
    // Fallback to localStorage if Redux state is empty
    if (!originalAdmin || !returnSchoolId || !returnStudentId || !originalAdminToken) {
      try {
        const storedContext = localStorage.getItem('impersonation_context');
        if (storedContext) {
          const context = JSON.parse(storedContext);
          originalAdmin = originalAdmin || context.originalAdminUser;
          originalAdminToken = originalAdminToken || context.originalAdminToken;
          returnSchoolId = returnSchoolId || context.returnSchoolId;
          returnStudentId = returnStudentId || context.returnStudentId;
        }
      } catch (e) {
        console.error('Failed to parse impersonation context from localStorage', e);
      }
    }
    
    // Restore admin token for API calls (x-authorization)
    if (originalAdminToken) {
      Storage.setTokenInCookie(originalAdminToken);
    }
    
    // Restore admin user in Redux
    if (originalAdmin) {
      dispatch(userInfoAction(originalAdmin));
      // Restore localStorage
      localStorage.setItem('user', JSON.stringify(originalAdmin));
    }
    
    // Clear impersonation state
    dispatch(stopImpersonation());
    
    // Get search state from impersonation context
    let searchInput = '';
    let optionValue = 'all';
    let schoolName = '';
    try {
      const storedContext = localStorage.getItem('impersonation_context');
      if (storedContext) {
        const context = JSON.parse(storedContext);
        searchInput = context.searchInput || '';
        optionValue = context.optionValue || 'all';
        schoolName = context.schoolName || '';
      }
    } catch (e) {
      console.error('Failed to parse search state from impersonation context', e);
    }
    
    // Store return context in localStorage for Student.js to read (including search state)
    if (returnSchoolId && returnStudentId) {
      localStorage.setItem('impersonation_return', JSON.stringify({
        schoolId: returnSchoolId,
        studentId: returnStudentId,
        searchInput: searchInput,
        optionValue: optionValue,
        schoolName: schoolName,
        timestamp: new Date().toISOString(),
      }));
    }
    
    // Navigate back to admin/students
    history.push('/admin/students', {
      returnFromImpersonation: true,
      schoolId: returnSchoolId,
      studentId: returnStudentId,
      searchInput: searchInput,
      optionValue: optionValue,
      schoolName: schoolName,
    });
  };

  return (
    <>
      <ReactCSSTransitionGroup
        component="div"
        // className={cx("app-header", headerBackgroundColor, {
        //   "header-shadow": enableHeaderShadow,
        // })}
        className={cx("app-header", headerBackgroundColor)}
        transitionName="HeaderAnimation"
        transitionAppear={true}
        transitionAppearTimeout={1500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <HeaderLogo />

        <div
          className={cx("app-header__content", {
            "header-mobile-open": enableMobileMenuSmall,
          })}
        >
          <div className="app-header-left">
            {/* Impersonation Banner inside header */}
            {impersonation?.isImpersonating && (
              <div
                style={{
                  backgroundColor: "#ff9800",
                  color: "white",
                  padding: "4px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  fontSize: "13px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  marginLeft: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                <span>
                 You are currently impersonating <strong>[{impersonation?.impersonatedStudent?.first_name} {impersonation?.impersonatedStudent?.last_name}]</strong> (Student)
                </span>
                <button
                  onClick={handleExitImpersonation}
                  style={{
                    backgroundColor: "white",
                    color: "#ff9800",
                    border: "none",
                    borderRadius: "4px",
                    padding: "3px 12px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                >
                  Stop Impersonating
                </button>
              </div>
            )}
            {user.role === "counselor" && (
              <div
                style={{
                  //marginRight:"30%",
                  justifyContent: "left",
                  position: "relative",
                  marginTop: "10px",
                }}
              >
                <div className="school-selector-container" style={{ display: "flex", alignItems: "left" }}>
                  {schoolName ? (
                    <>
                      <p
                        onClick={openSchoolOptionHandler}
                        className="no-margin-bottom cursor"
                        style={{ textDecoration: "underline", fontSize: "22px", marginRight: "10px" }}
                      >
                        {schoolName}
                      </p>
                      <span
                        onClick={() => {
                          setSchoolName(""); // Clear the school name
                          setSelectedSchool(null); // Clear selected school
                          setSchoolName1(""); // Clear search input
                          setOpenSchoolOption(true); // Open the container
                          // Focus on search input after a short delay
                          setTimeout(() => {
                            if (schoolNameRef.current) {
                              schoolNameRef.current.focus();
                            }
                          }, 100);
                        }}
                        style={{
                          cursor: "pointer",
                          fontSize: "16px",
                          fontWeight: "bold",
                          padding: "0 5px",
                          color: "red", // Red X
                          marginLeft: "5px"
                        }}
                      >
                        ✕
                      </span>
                    </>
                  ) : (
                    <p
                      onClick={openSchoolOptionHandler}
                      className="no-margin-bottom cursor"
                      style={{ textDecoration: "underline", fontSize: "22px" }}
                    >
                      Select School
                    </p>
                  )}
                </div>

                {openSchoolOption && (
                  <div
                    style={{
                      position: "absolute",
                      background: "white",
                      padding: "15px",
                      zIndex: "10",
                      width: "400px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      borderRadius: "4px",
                      maxHeight: "650px",
                      overflowY: "auto"
                    }}
                  >
                    <input
                      ref={schoolNameRef}
                      className="search-student-input2"
                      type="text"
                      style={{
                        width: "100%",
                        height: "35px",
                        padding: "5px 10px",
                        marginBottom: "10px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        position: "sticky",
                        top: "0",
                        backgroundColor: "white",
                        zIndex: "1"
                      }}
                      placeholder="Search school..."
                      value={schoolName1 || ""}
                      onChange={handleSchoolName}
                      autoComplete="off"
                    />

                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      {showSchoolNameContainer ? (
                        schoolNameList && schoolNameList.length > 0 ? (
                          schoolNameList.map((item, index) => (
                            <div
                              key={index}
                              onClick={() => selectSchoolOptionHandler(item)}
                              className="school-option"
                              style={{
                                padding: "8px 5px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "skyblue";
                                e.currentTarget.style.color = "white";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                                e.currentTarget.style.color = "inherit";
                              }}
                            >
                              <p className="no-margin-bottom">{item.name}</p>
                            </div>
                          ))
                        ) : (
                          <p style={{ textAlign: "center", color: "#666" }}>No schools found</p>
                        )
                      ) : (
                        user?.schools_name?.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => selectSchoolOptionHandler(item)}
                            className="school-option"
                            style={{
                              padding: "8px 5px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                              transition: "all 0.2s ease",
                              backgroundColor: item.name === schoolName ? "#f0f0f0" : "transparent"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "skyblue";
                              e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = item.name === schoolName ? "#f0f0f0" : "transparent";
                              e.currentTarget.style.color = "inherit";
                            }}
                          >
                            <p className="no-margin-bottom">{item.name}</p>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {user.role === "school_it" && user.school_student_progress_enable === true && (
              <div
                style={{
                  //marginRight:"30%",
                  justifyContent: "center",
                  position: "relative",
                  marginTop: "10px",
                }}
              >
                <div>
                  <input
                    ref={schoolNameRef}
                    className="search-student-input2"
                    type="text"
                    style={{
                      width: "350px",
                      height: "35px",
                      padding: "5px 10px",
                      marginBottom: "10px",
                    }}
                    placeholder="School Name"
                    value={schoolName1}
                    onChange={handleSchoolName}
                    autoComplete="off"
                  />
                  {showSchoolNameContainer && (
                    <div style={{ position: "absolute" }}>
                      <ul
                        className="maintain-group-student-dropdown-menu"
                        style={{
                          width: "550px",
                          maxHeight: "600px",
                          overflowY: "scroll",
                          borderRadius: "5px",
                          padding: "10px",
                        }}
                      >
                        {schoolNameLoading && <CustomLoader />}
                        {schoolNameList?.length > 0 &&
                          schoolNameList.map((item, index) => (
                            <li
                              onClick={() => handleSelectedSchoolName(item)}
                              key={index}
                              className="flex cursor"
                              style={{ padding: "5px 0px" }}
                            >
                              <span>{item.name}</span>
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>


              </div>
            )}
          </div>
          <div className="app-header-left header-dots" style={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: '10px' }}>
            {(user.role == Roles.STUDENT_NAME || user.role == Roles.PARENT_NAME) && (
              <div style={{ marginTop: 6, transform: 'translateX(-6px)' }}>
                <Switch
                  onChange={handleLanguageToggle}
                  checked={languageEs}
                  width={52}
                  height={24}
                  handleDiameter={18}
                  onColor={"#28131A"}
                  offColor={"#049804"}
                  uncheckedIcon={<div className="switchIncon uncheckIcon">EN</div>}
                  checkedIcon={<div className="switchIncon checkIcon">ES</div>}
                  className="langSwitch"
                />
              </div>
            )}
            {user.role == Roles.STUDENT_NAME || user.role == Roles.PARENT_NAME ? <HeaderDots /> : ""}
            {user.role == Roles.COUNSELOR_NAME || user.role == Roles.ADMIN_NAME || user.role == Roles.RECRUITER_NAME ? (
              <div className="icon-wrapper icon-wrapper-alt" onClick={handleBellClick}>
                <img src={MessageBell} alt='notifyIcon' width={32} height={26} className='img-fluid' />
                {notificationCount ? (
                  <div className="badge badge-dot notifyBadge">{notificationCount > 99 ? '99+' : notificationCount}</div>
                ) : ''}
              </div>
            ) : ''}
            <UserBox />
          </div>
        </div>
      </ReactCSSTransitionGroup>
    </>
  )
}

export default Header;
